import React from 'react';
import {Grid} from '@mui/material';
import {makeStyles} from "@mui/styles";
import "react-datepicker/dist/react-datepicker.css";
import ChartValue from "./ChartValue"
import {addCommaToEvery3Digits} from "../../lib";
const useStyles = makeStyles(() => ({
  title: {
    marginTop: 8,
    fontSize: 16,
    fontWeight: 700,
    fontFamily: "NotoSansKR",
    color: "#1a173b"
  },
  countBox: {
    height: 36,
    borderRadius: 6,
    padding: "6px 16px",
    marginLeft: 32,
    backgroundColor: "#FFFFFF",
    border: "1px solid rgba(0,0,0,.1)",
  },
  bullet: {
    width: 10,
    height: 10,
    marginTop: 6,
    marginRight: 8,
    borderRadius: 50,
    backgroundColor: "#cce9d9"
  },
  text: {
    fontWeight:600,
    color: "#77787F",
    marginRight: 16
  },
  bar: {
    width: 2,
    height: 16,
    marginTop: 3,
    backgroundColor: "rgba(0,0,0,.1)"
  },
  value: {
    marginLeft: 16,
    fontWeight: "bold",
  }
}));


export default function ChartContents(props: any) {
  const classes = useStyles();
  const {title, countBoxTitle, totalValue, chartName, standard, data, type} = props;
  return (
    <>
      <Grid container direction={"column"}>
        <Grid item>
          <Grid container direction={"row"}>
            <Grid item className={classes.title}>{title}</Grid>
            <Grid item className={classes.countBox}>
              <Grid container direction={"row"} >
                <div className={classes.bullet}/>
                <div className={classes.text}>{countBoxTitle}</div>
                <div className={classes.bar}/>
                <div className={classes.value}>{addCommaToEvery3Digits(Number(totalValue))}{standard}</div>
              </Grid>
              <Grid container direction={"row"} >
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <ChartValue totalValue={totalValue} chartName={chartName} standard={standard} data={data} type={type}/>
        </Grid>
      </Grid>
    </>
  )
}